function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, Children } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import findAndDecorateImageProps from '../utils/findAndDecorateImageProps';
import findAndDecorateProductMetaProps from './findAndDecorateMetaProps';
import ProductMeta from './ProductMeta';
import MediaFrame from '../MediaFrame';
import Icon from '../Icon';
/**
 * The Product component is used to display products in a list or grid for commerce
 * or library purposes
 *
 * - [Metropolis Style Guide](https://confluence.sie.sony.com/pages/viewpage.action?spaceKey=PPRC1&title=Product+Tiles)
 *
 * ## Usage
 *
 * ```jsx
 * <Product
 *   variant="grid"
 *   image={(
 *    <>
 *      <Media src="https://image.com/1" alt="product image" />
 *      <Tag className="m-s bottom-left">PS4</Tag>
 *    </>
 *   )}
 *   tags={(
 *     <>
 *       {[1,2,3,4].map(x => (<Tag key={x}>{`TAG ${x}`}</Tag>))}
 *     </>
 *   )}
 *   price="$4.99"
 *   name="Best Game Ever"
 *   publisherName="SIE"
 *   editionName="Super Ultra Mega Lightning Edition"
 *   releaseDate="December 12, 2019"
 * />
 * ```
 *
 * With composed details
 *
 * ```jsx
 * <Product
 *   variant="grid"
 *   image={(
 *    <>
 *      <Media src="https://image.com/1" alt="product image" />
 *      <Tag className="m-s bottom-left">PS4</Tag>
 *    </>
 *   )}
 * >
 *   <div className="p-s l-line-repel">
 *     <ProductMeta
 *       tags={(
 *         <>
 *           {[1,2,3,4].map(x => (<Tag key={x}>{`TAG ${x}`}</Tag>))}
 *         </>
 *       )}
 *       price="$4.99"
 *       name="Best Game Ever"
 *       publisherName="SIE"
 *       editionName="Super Ultra Mega Lightning Edition"
 *       releaseDate="December 12, 2019"
 *     />
 *     <Button variant="quick-action">
 *        <Icon type="more" />
 *     </Button>
 *   </div>
 * </Product>
 * ```
 *
 * ## Props
 */

var Product = /*#__PURE__*/function (_PureComponent) {
  _inherits(Product, _PureComponent);

  var _super = _createSuper(Product);

  function Product() {
    _classCallCheck(this, Product);

    return _super.apply(this, arguments);
  }

  _createClass(Product, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          image = _this$props.image,
          tags = _this$props.tags,
          name = _this$props.name,
          price = _this$props.price,
          publisherName = _this$props.publisherName,
          editionName = _this$props.editionName,
          releaseDate = _this$props.releaseDate,
          size = _this$props.size,
          variant = _this$props.variant,
          children = _this$props.children;

      var _Product$getClassName = Product.getClassName({
        className: className,
        variant: variant,
        size: size
      }),
          root = _Product$getClassName.root,
          metaClass = _Product$getClassName.meta,
          imageClass = _Product$getClassName.image;

      var fallback = /*#__PURE__*/React.createElement(MediaFrame, {
        className: "psw-bg-3",
        aspectRatio: "1:1"
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "psw-center",
        type: "games",
        size: "m"
      }));
      var decoratedImage = findAndDecorateImageProps(image, {
        qa: "".concat(qa, "#productImage"),
        width: '100%',
        className: 'psw-fill-x',
        children: fallback
      });
      var composedMeta = Children.toArray(children)[0];
      var decoratedMeta = findAndDecorateProductMetaProps(composedMeta, {
        qa: "".concat(qa, "#meta"),
        variant: variant,
        size: size
      });
      return /*#__PURE__*/React.createElement("article", {
        "data-qa": qa,
        className: root
      }, /*#__PURE__*/React.createElement("div", {
        className: imageClass
      }, decoratedImage || fallback), !children && /*#__PURE__*/React.createElement(ProductMeta, {
        qa: "".concat(qa, "#meta"),
        className: metaClass,
        variant: variant,
        size: size,
        name: name,
        tags: tags,
        publisherName: publisherName,
        releaseDate: releaseDate,
        price: price,
        editionName: editionName
      }), decoratedMeta);
    }
  }]);

  return Product;
}(PureComponent);

var cx = classNamesFor(Product);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for Product
 */

Product.getClassName = function (_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      size = _ref.size;
  return {
    root: cx('psw-product', "psw-product--".concat(size), "psw-".concat(variant, "-product"), variant === 'list' ? 'psw-l-line-left-top' : 'psw-l-stack-left', className),
    meta: cx("psw-m-".concat(variant === 'list' ? 'l' : 't', "-s")),
    image: cx('psw-product-image', 'psw-l-anchor')
  };
};
/**
 * Defines aliases for classNames used by this component
 */


Product.useClassNames = function (classNames) {
  Product.classNames = classNames;
};

Product.defaultProps = {
  qa: '',
  className: '',
  image: null,
  tags: null,
  name: '',
  price: '',
  publisherName: '',
  editionName: '',
  releaseDate: '',
  variant: 'list',
  size: 'medium',
  children: null
};
Product.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Determines the presentational variant of the Product. If used within a Product
   * component this property will be inherited.
   */
  variant: PropTypes.oneOf(['list', 'grid']),

  /**
   * Size as defined in the Metropolis style guide for Product Tiles. If used within a Product
   * component this property will be inherited.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * The image representing the Product. This can be composed jsx but should
   * include a Media component at most one level deep.
   */
  image: PropTypes.node,

  /**
   * The list of tags to be displayed for the products as jsx
   */
  tags: PropTypes.node,

  /**
   * The name of the product / game
   */
  name: PropTypes.string,

  /**
   * The price of the game. For more complex price layouts jsx is accepted
   */
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * The publisher name for the game / product
   */
  publisherName: PropTypes.string,

  /**
   * The edition name for the game / product
   */
  editionName: PropTypes.string,

  /**
   * When the game was / is going to be released
   */
  releaseDate: PropTypes.string,

  /**
   * Used to compose the Product details display
   * - Add padding to details keeping image full width
   * - Add additional UI components
   */
  children: PropTypes.node
};
export default Product;